module.exports = __webpack_public_path__ + "engineering.348_2kuB.svg";